// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ProcessGroupIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ProcessGroupIcon" ref={forwardedRef} {...props}>
      <path d="M4 3H3v14h1v1.5H1.5v-17H4z" />
      <path d="M18.5 18.5H16V17h1V3h-1V1.5h2.5z" />
      <path d="M14 3.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3.125V8H14a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-3.125V13H14a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H6l-.103-.005a1 1 0 0 1-.892-.893L5 15.5V14l.005-.102a1 1 0 0 1 .892-.893L6 13h3.125v-1.5H6l-.103-.005a1 1 0 0 1-.892-.893L5 10.5V9l.005-.103a1 1 0 0 1 .892-.892L6 8h3.125V6.5H6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM6.25 15.25h7.5v-1h-7.5zm0-5h7.5v-1h-7.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ProcessGroupIcon = /* @__PURE__ */ Object.assign(
  ProcessGroupIconComponent,
  { displayName: 'ProcessGroupIcon' },
);
